import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-accordion"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "c-accordion__title" }
const _hoisted_4 = { class: "c-accordion__content" }
const _hoisted_5 = { class: "c-accordion__inner" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return ($data.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.currentTrim.description_extended, (item, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: _normalizeClass(["c-accordion__item", {'-is-active': $options.isActive(key)}])
          }, [
            _createElementVNode("div", {
              class: "c-accordion__header",
              onClick: $event => ($options.toggle(key))
            }, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(item.titre), 1 /* TEXT */),
              _createVNode(_component_svgIco, { icon: "arrow-down" })
            ], 8 /* PROPS */, _hoisted_2),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "o-text",
                  innerHTML: $options.toUlLi(item.description)
                }, null, 8 /* PROPS */, _hoisted_6)
              ])
            ])
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}